import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import "./styles.less";

export const Drawer = (props) => {
  const { visible, className, position, children, onClose } = props;
  // 定时器
  const timer = useRef(null);
  // 容器实例
  const [container, setContainer] = useState(null);
  // 容器展示的状态
  const [containerOpen, setContainerOpen] = useState(false);
  // 内容显示的状态
  const [contentOpen, setContentOpen] = useState(false);
  // 控制容器
  useEffect(() => {
    const target = document.body;
    if (target) setContainer(target);
  }, []);

  // 控制延时器
  useEffect(() => {
    if (visible) {
      // 容器先进
      setContainerOpen(true);
      // 内容后进
      timer.current = setTimeout(() => {
        setContentOpen(true);
      }, 200);
    } else {
      // 内容先出
      setContentOpen(false);
      // 容器后出
      timer.current = setTimeout(() => {
        setContainerOpen(false);
      }, 200);
    }
  }, [visible]);
  // 删除定时器
  useEffect(() => {
    return () => {
      if (timer.current) timer.current = null;
    };
  });
  const DrawerElement = (
    <div
      className={
        className
          ? `${className} authing-drawer-container`
          : "authing-drawer-container"
      }
      onClick={(ev) => {
        if (
          ev.nativeEvent.target.getAttribute("class") ===
          "authing-drawer-container"
        ) {
          onClose();
        }
      }}
    >
      <div
        className={
          contentOpen
            ? `authing-drawer-content ${position} visible`
            : `authing-drawer-content ${position}`
        }
      >
        {children ? children : "暂无内容"}
      </div>
    </div>
  );
  return container && containerOpen
    ? ReactDOM.createPortal(DrawerElement, container)
    : null;
};
/**
 * @param {position} 出现的位置 left|right
 */
Drawer.defaultProps = {
  visible: false,
  position: "top",
};
